import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { ProductAttributesDirective } from './product-attributes.directive';
export var ProductAttributesComponentNgModule = module(baseModuleId + ".product-attributes", [])
    .directive('productAttributes', ProductAttributesDirective);
